// You can write more code here

/* START OF COMPILED CODE */

import TilemapScene from "./TilemapScene";
import Player from "../../prefabs/World/Player";
import WorldNode from "../../prefabs/World/WorldNode";
import Portal from "../../prefabs/World/Portal";
import ForestTree1 from "../../prefabs/World/ForestTree1";
import Mentor5 from "../../prefabs/World/Mentors/Mentor5";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level22 extends TilemapScene {

	constructor() {
		super("Level22");

		/* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
	}

	editorCreate(): void {

		// tropical_biome_2
		const tropical_biome_2 = this.add.tilemap("tropical-biome-2");
		tropical_biome_2.addTilesetImage("tropical shores", "tropical shores");
		tropical_biome_2.addTilesetImage("tropical shores prefabs & samples", "tropical shores prefabs & samples");
		tropical_biome_2.addTilesetImage("tropical shores, just trees", "tropical shores, just trees");
		tropical_biome_2.addTilesetImage("collision", "collision & alpha");

		// terrain_1
		tropical_biome_2.createLayer("terrain", ["tropical shores prefabs & samples","tropical shores"], 0, 0);

		// water_1
		tropical_biome_2.createLayer("water", ["tropical shores prefabs & samples"], 0, 0);

		// cliffs_1
		tropical_biome_2.createLayer("cliffs", ["tropical shores"], 0, 0);

		// deco_1
		tropical_biome_2.createLayer("deco", ["tropical shores"], 0, 0);

		// bushes_1
		tropical_biome_2.createLayer("bushes", ["tropical shores, just trees"], 0, 0);

		// cOLLISION_1
		const cOLLISION_1 = tropical_biome_2.createLayer("COLLISION", ["collision"], 0, 0)!;
		cOLLISION_1.visible = false;

		// player
		const player = new Player(this, 280, 48);
		this.add.existing(player);

		// worldNode
		const worldNode = new WorldNode(this, 328, 80);
		this.add.existing(worldNode);

		// worldNode_1
		const worldNode_1 = new WorldNode(this, 504, 184);
		this.add.existing(worldNode_1);

		// worldNode_2
		const worldNode_2 = new WorldNode(this, 656, 336);
		this.add.existing(worldNode_2);

		// worldNode_3
		const worldNode_3 = new WorldNode(this, 224, 264);
		this.add.existing(worldNode_3);

		// worldNode_4
		const worldNode_4 = new WorldNode(this, 560, 472);
		this.add.existing(worldNode_4);

		// worldNode_5
		const worldNode_5 = new WorldNode(this, 136, 464);
		this.add.existing(worldNode_5);

		// portal
		const portal = new Portal(this, 48, 496);
		this.add.existing(portal);

		// forestTree_1
		const forestTree_1 = new ForestTree1(this, 216, 208, "tropical_trees_sheet", 0);
		this.add.existing(forestTree_1);

		// forestTree_2
		const forestTree_2 = new ForestTree1(this, 168, 288, "tropical_trees_sheet", 0);
		this.add.existing(forestTree_2);

		// forestTree_3
		const forestTree_3 = new ForestTree1(this, 120, 320, "tropical_trees_sheet", 0);
		this.add.existing(forestTree_3);

		// forestTree_5
		const forestTree_5 = new ForestTree1(this, 56, 288, "tropical_trees_sheet", 0);
		this.add.existing(forestTree_5);

		// forestTree_6
		const forestTree_6 = new ForestTree1(this, 104, 272, "tropical_trees_sheet", 0);
		this.add.existing(forestTree_6);

		// forestTree_7
		const forestTree_7 = new ForestTree1(this, 120, 240, "tropical_trees_sheet", 0);
		this.add.existing(forestTree_7);

		// forestTree_8
		const forestTree_8 = new ForestTree1(this, 152, 224, "tropical_trees_sheet", 0);
		this.add.existing(forestTree_8);

		// forestTree_9
		const forestTree_9 = new ForestTree1(this, 56, 208, "tropical_trees_sheet", 0);
		this.add.existing(forestTree_9);

		// forestTree_4
		const forestTree_4 = new ForestTree1(this, 72, 336, "tropical_trees_sheet", 2);
		this.add.existing(forestTree_4);

		// forestTree_15
		const forestTree_15 = new ForestTree1(this, 184, 304, "tropical_trees_sheet", 2);
		this.add.existing(forestTree_15);

		// forestTree_16
		const forestTree_16 = new ForestTree1(this, 232, 240, "tropical_trees_sheet", 2);
		this.add.existing(forestTree_16);

		// forestTree_17
		const forestTree_17 = new ForestTree1(this, 40, 272, "tropical_trees_sheet", 2);
		this.add.existing(forestTree_17);

		// forestTree_18
		const forestTree_18 = new ForestTree1(this, 40, 224, "tropical_trees_sheet", 2);
		this.add.existing(forestTree_18);

		// forestTree_19
		const forestTree_19 = new ForestTree1(this, 88, 240, "tropical_trees_sheet", 2);
		this.add.existing(forestTree_19);

		// forestTree_20
		const forestTree_20 = new ForestTree1(this, 88, 192, "tropical_trees_sheet", 2);
		this.add.existing(forestTree_20);

		// forestTree_21
		const forestTree_21 = new ForestTree1(this, 120, 160, "tropical_trees_sheet", 2);
		this.add.existing(forestTree_21);

		// forestTree_22
		const forestTree_22 = new ForestTree1(this, 168, 144, "tropical_trees_sheet", 2);
		this.add.existing(forestTree_22);

		// forestTree_23
		const forestTree_23 = new ForestTree1(this, 184, 144, "tropical_trees_sheet", 2);
		this.add.existing(forestTree_23);

		// forestTree_24
		const forestTree_24 = new ForestTree1(this, 152, 128, "tropical_trees_sheet", 2);
		this.add.existing(forestTree_24);

		// forestTree_25
		const forestTree_25 = new ForestTree1(this, 248, 160, "tropical_trees_sheet", 2);
		this.add.existing(forestTree_25);

		// forestTree_26
		const forestTree_26 = new ForestTree1(this, 264, 192, "tropical_trees_sheet", 2);
		this.add.existing(forestTree_26);

		// forestTree_27
		const forestTree_27 = new ForestTree1(this, 280, 144, "tropical_trees_sheet", 2);
		this.add.existing(forestTree_27);

		// forestTree_28
		const forestTree_28 = new ForestTree1(this, 408, 224, "tropical_trees_sheet", 2);
		this.add.existing(forestTree_28);

		// forestTree_29
		const forestTree_29 = new ForestTree1(this, 504, 272, "tropical_trees_sheet", 2);
		this.add.existing(forestTree_29);

		// forestTree_30
		const forestTree_30 = new ForestTree1(this, 88, 416, "tropical_trees_sheet", 2);
		this.add.existing(forestTree_30);

		// forestTree_31
		const forestTree_31 = new ForestTree1(this, 88, 336, "tropical_trees_sheet", 1);
		this.add.existing(forestTree_31);

		// forestTree_32
		const forestTree_32 = new ForestTree1(this, 168, 240, "tropical_trees_sheet", 1);
		this.add.existing(forestTree_32);

		// forestTree_33
		const forestTree_33 = new ForestTree1(this, 40, 192, "tropical_trees_sheet", 1);
		this.add.existing(forestTree_33);

		// forestTree_34
		const forestTree_34 = new ForestTree1(this, 88, 160, "tropical_trees_sheet", 1);
		this.add.existing(forestTree_34);

		// forestTree_35
		const forestTree_35 = new ForestTree1(this, 760, 128, "tropical_trees_sheet", 1);
		this.add.existing(forestTree_35);

		// forestTree_36
		const forestTree_36 = new ForestTree1(this, 824, 320, "tropical_trees_sheet", 1);
		this.add.existing(forestTree_36);

		// mentor
		const mentor = new Mentor5(this, 224, 80);
		this.add.existing(mentor);

		// worldNode_6
		const worldNode_6 = new WorldNode(this, 272, 392);
		this.add.existing(worldNode_6);

		// worldNode_7
		const worldNode_7 = new WorldNode(this, 464, 296);
		this.add.existing(worldNode_7);

		// worldNode_8
		const worldNode_8 = new WorldNode(this, 480, 88);
		this.add.existing(worldNode_8);

		// worldNode_9
		const worldNode_9 = new WorldNode(this, 400, 424);
		this.add.existing(worldNode_9);

		// forestTree
		const forestTree = new ForestTree1(this, 32, 360, "tropical_trees_sheet", 6);
		this.add.existing(forestTree);

		// forestTree_10
		const forestTree_10 = new ForestTree1(this, 568, 288, "tropical_trees_sheet", 6);
		this.add.existing(forestTree_10);

		// forestTree_11
		const forestTree_11 = new ForestTree1(this, 608, 264, "tropical_trees_sheet", 6);
		this.add.existing(forestTree_11);

		// forestTree_13
		const forestTree_13 = new ForestTree1(this, 456, 464, "tropical_trees_sheet", 6);
		this.add.existing(forestTree_13);

		// forestTree_37
		const forestTree_37 = new ForestTree1(this, 392, 144, "tropical_trees_sheet", 6);
		this.add.existing(forestTree_37);

		// forestTree_12
		const forestTree_12 = new ForestTree1(this, 664, 288, "tropical_trees_sheet", 6);
		this.add.existing(forestTree_12);

		// forestTree_38
		const forestTree_38 = new ForestTree1(this, 280, 288, "tropical_trees_sheet", 6);
		this.add.existing(forestTree_38);

		// worldNode (prefab fields)
		worldNode.NPCLevelId = 21;
		worldNode.NPCId = 0;

		// worldNode_1 (prefab fields)
		worldNode_1.NPCLevelId = 21;
		worldNode_1.NPCId = 1;

		// worldNode_2 (prefab fields)
		worldNode_2.NPCLevelId = 21;
		worldNode_2.NPCId = 2;

		// worldNode_3 (prefab fields)
		worldNode_3.NPCLevelId = 21;
		worldNode_3.NPCId = 3;

		// worldNode_4 (prefab fields)
		worldNode_4.NPCLevelId = 21;
		worldNode_4.NPCId = 4;

		// worldNode_5 (prefab fields)
		worldNode_5.NPCLevelId = 21;
		worldNode_5.NPCId = 5;

		// worldNode_6 (prefab fields)
		worldNode_6.NPCLevelId = 21;
		worldNode_6.NPCId = 5;

		// worldNode_7 (prefab fields)
		worldNode_7.NPCLevelId = 21;
		worldNode_7.NPCId = 5;

		// worldNode_8 (prefab fields)
		worldNode_8.NPCLevelId = 21;
		worldNode_8.NPCId = 5;

		// worldNode_9 (prefab fields)
		worldNode_9.NPCLevelId = 21;
		worldNode_9.NPCId = 5;

		this.player = player;
		this.portal = portal;
		this.mentor = mentor;
		this.tropical_biome_2 = tropical_biome_2;

		this.events.emit("scene-awake");
	}

	private player!: Player;
	private portal!: Portal;
	private mentor!: Mentor5;
	private tropical_biome_2!: Phaser.Tilemaps.Tilemap;

	/* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.tropical_biome_2,
      portal: this.portal,
      mentor: this.mentor,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
